import React, { useState } from "react";
import Sidebar from "../newFacebookCampaign/Sidebar";
import { createGoogleCampaignTabs } from "../newFacebookCampaign/GoogleAutomationConstants";
import CreateGoogleCampaignTemplate from "./CreateGoogleCampaignTemplate";

const LayoutGoogleAutomation = () => {
  const [activeStep, setActiveStep] = useState(1);
  return (
    <div>
      <div className="flex h-[90vh] gap-10">
        <div className="flex flex-col gap-2">
          <div>
            <span
              style={{ fontWeight: "bold", fontSize: "24px", color: "black" }}
            >
              AD Manage
            </span>
            <span
              style={{
                fontWeight: "normal",
                fontSize: "24px",
                color: "blue",
                marginLeft: "4px",
              }}
            >
              Plus
            </span>
          </div>
          <Sidebar
            step={activeStep}
            setStep={(val) => setActiveStep(val)}
            navigationTabs={createGoogleCampaignTabs}
          />
        </div>
        <div className="w-full">
          <div className="flex flex-col gap-2 mb-5">
            <span
              style={{ fontWeight: "bold", fontSize: "24px", color: "black" }}
            >
              Create Campaign{" "}
            </span>
          </div>
          <div className="w-full">
            <CreateGoogleCampaignTemplate
              currentStep={activeStep}
              nextStep={(val) => setActiveStep(val)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutGoogleAutomation;
